// ***************
// src/app/services/c_autologout.js
// autor: WdePaula / MVinfo
// data: 16/9/24 | 19h06
// data: 30/12/24 | 13h03 - removemos o localStorage.clear e individualizamos as remoções
// efetuar o autologout caso esteja faltando ou com problema nos tokens no agendexClienteWeb
// ***************




export const C_AutoLogout = () => {
    // localStorage.clear(); // substituída pela linha abaixo 30/12/24w
    localStorage.removeItem("tokenlg");
    localStorage.removeItem("tokenacw");
    localStorage.removeItem("tokenasw");

    window.location.href = "/app/login/cliente";
};
